"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var condition_reader_1 = require("./condition-reader");
var immutable_1 = require("immutable");
var simple_condition_reader_1 = require("./simple-condition-reader");
var GroupingConditionReader = /** @class */ (function (_super) {
    __extends(GroupingConditionReader, _super);
    function GroupingConditionReader() {
        return _super.call(this, new simple_condition_reader_1.SimpleConditionReader()) || this;
    }
    GroupingConditionReader.prototype.internalRead = function (key, value) {
        switch (key) {
            case '$and':
            case '$group-and':
                if (!Array.isArray(value)) {
                    throw new Error('parameter of and operator was not an array');
                }
                var andPredicates_1 = value;
                return function (context) { return andPredicates_1.every(function (predicate) { return predicate(context); }); };
            case '$or':
            case '$group-or':
                if (!Array.isArray(value)) {
                    throw new Error('parameter of and operator was not an array');
                }
                var orPredicates_1 = value;
                return function (context) { return orPredicates_1.some(function (predicate) { return predicate(context); }); };
            case '$not':
                var notPredicate_1 = value;
                return function (context) { return !notPredicate_1(context); };
        }
    };
    GroupingConditionReader.prototype.isSupported = function (key) {
        return GroupingConditionReader.supportedKeys.contains(key);
    };
    GroupingConditionReader.supportedKeys = immutable_1.Seq.Set(['$and', '$or', '$not', '$group-and', '$group-or']);
    return GroupingConditionReader;
}(condition_reader_1.ConditionReader));
exports.GroupingConditionReader = GroupingConditionReader;
//# sourceMappingURL=grouping-condition-reader.js.map